import 'react';
import styled, { ThemeProvider, css } from 'styled-components';
import getTheme from '../../../../../utils/getTheme.js';
import { jsx } from 'react/jsx-runtime';
const TRAPDOOR_BOX_SHADOW = '0px 8px 24px 0px rgba(0, 0, 0, 0.12)';
const duration = 300;
function TrapdoorContentWrapper({
  $isActive,
  children
}) {
  /* Trapdoor uses default (white) theme */
  const theme = getTheme('default');
  return /*#__PURE__*/jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/jsx(Wrapper, {
      $isActive: $isActive,
      children: /*#__PURE__*/jsx(InnerWrapper, {
        children: children
      })
    })
  });
}
const Wrapper = styled.section`
  width: 100%;
  max-width: max-content;
  text-align: left;
  visibility: hidden; /* visibility used for CLS improvements */
  pointer-events: none;
  position: absolute;
  z-index: ${({
  theme
}) => theme.zIndex.high};
  top: calc(100% + 1px);
  left: 50%;
  transform: translateX(-50%);
  box-sizing: border-box;
  opacity: ${p => p.$isActive ? 1 : 0};
  transition: all ${({
  $isActive
}) => $isActive ? duration : duration / 2}ms
    ease-in-out;
  ${({
  $isActive
}) => {
  return $isActive ? css`
          pointer-events: all;
          display: block;
          visibility: visible; /* visibility used for CLS improvements */
        ` : '';
}}
`;
const InnerWrapper = styled.div`
  padding: 24px;
  background: ${({
  theme
}) => theme.color.background};
  margin: 12px auto 24px;
  display: flex;
  justify-content: center;
  box-shadow: ${TRAPDOOR_BOX_SHADOW};
  border-radius: 24px;
`;
export { TrapdoorContentWrapper as default };
//# sourceMappingURL=TrapdoorContentWrapper.js.map
